import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

type SearchBoxProps = {
  defaultValue?: string;
  placeholder?: string;
  size?: 'sm' | 'lg';
  autoFocus?: boolean;
};

export default function SearchBox({
  defaultValue = '',
  placeholder = '搜索网站、分类或关键词…',
  size = 'sm',
  autoFocus = false,
}: SearchBoxProps) {
  const [value, setValue] = useState(defaultValue);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    if (!keyword) {
      setError('请输入搜索关键词后再搜索');
      return;
    }
    setError('');
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  };

  const sizeClasses =
    size === 'lg'
      ? 'h-14 text-base pl-12 pr-32 rounded-lg'
      : 'h-10 text-sm pl-10 pr-20 rounded-md';

  const iconPosition = size === 'lg' ? 'left-4 text-xl' : 'left-3 text-base';

  return (
    <form onSubmit={handleSubmit} className="w-full" role="search">
      <div className="relative w-full">
        <span
          className={`pointer-events-none absolute top-1/2 -translate-y-1/2 text-foreground-400 ${iconPosition}`}
        >
          <i className="ri-search-2-line"></i>
        </span>
        <input
          type="text"
          value={value}
          autoFocus={autoFocus}
          onChange={(event) => {
            setValue(event.target.value);
            if (error) setError('');
          }}
          placeholder={placeholder}
          aria-label="站内搜索"
          className={`w-full border bg-background-50 text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100 ${sizeClasses} ${
            error ? 'border-accent-400' : 'border-background-300'
          }`}
        />
        <button
          type="submit"
          className={`absolute right-1.5 top-1/2 flex -translate-y-1/2 cursor-pointer items-center gap-1 whitespace-nowrap bg-primary-500 font-medium text-background-50 transition-colors hover:bg-primary-600 ${
            size === 'lg'
              ? 'h-11 rounded-md px-6 text-sm'
              : 'h-7 rounded-[5px] px-4 text-xs'
          }`}
        >
          <i className="ri-search-line"></i>
          搜索
        </button>
      </div>
      {error && (
        <p className="mt-2 flex items-center gap-1 text-xs text-accent-700">
          <i className="ri-error-warning-line"></i>
          {error}
        </p>
      )}
    </form>
  );
}